<template>
  <section v-if="isMobile" class="larger-banner-area">
    <div class="larger-banner-container">
      <swiper ref="largerBanner" :options="swiperOption">
        <swiper-slide
          v-for="(slide, index) in slides"
          :key="index"
        >
          <a :href="`${slide.link}${queryString ? '?' + queryString : ''}`">
            <img
              :src="getResponsiveImageUrl(slide.image)"
              alt="pic"
              @load="handleImageLoad"
            />
          </a>
        </swiper-slide>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
      </swiper>
    </div>
    <!-- 將 pagination 移到 swiper 外部 -->
    <div class="custom-pagination">
      <span
        v-for="(slide, index) in slides"
        :key="index"
        :class="['pagination-bullet', { 'active': currentSlide === index }]"
        @click="goToSlide(index)"
      ></span>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

export default {
  name: 'LargerBanner',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    imageUrl: {
      type: String,
      required: true
    },
    queryString: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentSlide: 0,
      bannerHeight: 'auto',
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      swiperOption: {
        spaceBetween: 20,
        centeredSlides: false, // 桌面版不居中
        slidesPerView: 'auto', // 自動計算顯示數量
        freeMode: false, // 禁用自由模式，保持對齊
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          // 移動設備配置
          320: {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 15
          },
          // 桌面設備配置
          1024: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 20,
            freeMode: false
          }
        }
      }
    }
  },
  methods: {
    goToSlide(index) {
      if (this.$refs.largerBanner && this.$refs.largerBanner.$swiper) {
        this.$refs.largerBanner.$swiper.slideTo(index)
        this.currentSlide = index
      }
    },
    handleImageLoad() {
      // 圖片載入完成後，重新計算swiper大小
      this.$nextTick(() => {
        if (this.$refs.largerBanner && this.$refs.largerBanner.$swiper)
          this.$refs.largerBanner.$swiper.update()
      })
    },
    handleResize() {
      // 監聽螢幕大小變化
      this.screenWidth = window.innerWidth
      this.screenHeight = window.innerHeight
    },
    getResponsiveImageUrl(originalImage) {
      // 根據螢幕解析度選擇對應的圖片尺寸
      const imageSize = this.getOptimalImageSize()

      // 假設圖片命名規則：原檔名_寬度x高度.副檔名
      // 例如：banner.jpg → banner_266x234.jpg
      const imageNameParts = originalImage.split('.')
      const extension = imageNameParts.pop()
      const baseName = imageNameParts.join('.')

      return `${this.imageUrl}/${baseName}_${imageSize.width}x${imageSize.height}.${extension}`
    },
    getOptimalImageSize() {
      // 所有設備都使用 428×487 高品質圖片
      return { width: 428, height: 487 }
    }
  },
  mounted() {
    // 確保初始狀態正確並綁定事件
    this.$nextTick(() => {
      if (this.$refs.largerBanner && this.$refs.largerBanner.$swiper) {
        const swiper = this.$refs.largerBanner.$swiper
        this.currentSlide = swiper.activeIndex

        // 綁定 slideChange 事件
        swiper.on('slideChange', () => {
          this.currentSlide = swiper.activeIndex
        })
      }
    })

    // 監聽螢幕大小變化
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除事件監聽器
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    isMobile() {
      // 現在所有設備都顯示banner，只是樣式不同
      return true
    },
    isDesktop() {
      return window.innerWidth >= 1024
    }
  }
}
</script>

<style lang="scss" scoped>
.larger-banner-area {
  position: relative;
  width: 100%;
  background-color: #1c1c1c; /* 恢復黑色背景 */
  margin-top: 80px; /* Add extra margin to ensure banner is not covered by header */
  z-index: 1; /* Lower than header */
  /* 移除任何高度限制，讓內部容器決定 */
  display: flex;
  flex-direction: column;
  align-items: center; /* 水平置中 */
  min-height: auto; /* 最小高度自動 */
  height: auto; /* 高度自動貼合內容 */
  padding: 0; /* 移除所有padding */

  .larger-banner-container {
    /* 移除width 100%，改為根據內容自適應 */
    max-width: 428px; /* 根據圖片比例設定最大寬度 */
    width: 95%; /* 增加寬度以減少留白 */
    padding: 0; /* 移除所有padding，完全貼合 */
    position: relative;
    overflow: visible; /* 確保 pagination 可見 */
    /* 容器本身不設定任何尺寸限制 */

                                                                                                                                .swiper-container {
      border-radius: 12px;
      overflow: hidden;
      background-color: #1c1c1c; /* 恢復黑色背景 */
      position: relative;
      z-index: 1;
      width: 100%; /* 確保容器填滿父元素 */
      height: auto; /* 高度自動，由圖片內容決定 */

      /* 移除aspect-ratio，讓圖片自然尺寸決定容器大小 */
    }

    // 確保swiper wrapper也能正確配合
    .swiper-wrapper {
      width: 100%;
      height: auto; /* 改為自動高度 */

      /* 移除絕對定位，讓內容自然流動 */
    }

    .swiper-slide {
      width: 100%;
      height: auto; /* 改為自動高度 */
      display: block; /* 改為block，簡化布局 */
      border-radius: 12px; /* 確保slide也有圓角 */
      overflow: hidden; /* 確保圓角生效 */

      a {
        display: block;
        width: 100%;
        height: auto;
        text-decoration: none;
        border-radius: 12px;
        overflow: hidden;
      }

      img {
        width: 100%; /* 圖片寬度100% */
        height: auto; /* 高度自動，保持圖片原始比例 */
        display: block;
        border-radius: 12px;
        /* 移除object-fit，讓圖片自然顯示 */
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      color: #fff;
      background: rgba(0, 0, 0, 0.4);
      width: 36px;
      height: 36px;
      border-radius: 50%;

      &:hover {
        background: rgba(0, 0, 0, 0.6);
      }

      &::after {
        font-size: 18px;
      }
    }

  }

  // 自定義 pagination 樣式
  .custom-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px; /* 進一步減少與banner的間距 */
    margin-bottom: 0; /* 移除下邊距 */
    height: 20px;

    .pagination-bullet {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin: 0 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      display: inline-block;

      // 第一個指示點 - 粉色
      &:nth-child(1) {
        background: #ff69b4;
      }

      // 第二個指示點 - 藍色
      &:nth-child(2) {
        background: #4169e1;
      }

      // 第三個指示點 - 青色
      &:nth-child(3) {
        background: #00bcd4;
      }

      // 第四個指示點 - 綠色
      &:nth-child(4) {
        background: #4caf50;
      }

      // 第五個指示點 - 黃色
      &:nth-child(5) {
        background: #ffeb3b;
      }

      // 第六個指示點 - 橙色
      &:nth-child(6) {
        background: #ff9800;
      }

      // 如果沒有匹配到顏色，使用白色
      &:nth-child(n+7) {
        background: #fff;
      }

      // 活動狀態
      &.active {
        transform: scale(1.3);
        box-shadow: 0 0 10px currentColor;
        filter: brightness(1.2);
      }

      // hover 效果
      &:hover {
        transform: scale(1.1);
        filter: brightness(1.1);
      }
    }
  }
}

/* 桌面版卡片輪播式設計 */
@media (min-width: 1024px) {
  .larger-banner-area {
    display: block;
    margin-top: 30px;
    padding: 20px 0;

    .larger-banner-container {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;

      .swiper-container {
        height: 280px;
        border-radius: 12px;
        overflow: visible; /* 讓卡片陰影可見 */
        background: transparent; /* 移除背景 */

        .swiper-wrapper {
          display: flex;
          align-items: center;
        }

        .swiper-slide {
          width: 350px !important; /* 固定卡片寬度 */
          height: 280px;
          margin-right: 20px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          transition: transform 0.3s ease, box-shadow 0.3s ease;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
          }

          a {
            display: block;
            width: 100%;
            height: 100%;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover; /* 桌面版使用cover填滿 */
            }
          }
        }

        /* 桌面版導航按鈕樣式 */
        .swiper-button-next,
        .swiper-button-prev {
          width: 50px;
          height: 50px;
          margin-top: -25px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 50%;
          color: #fff;

          &:hover {
            background: rgba(0, 0, 0, 0.9);
            transform: scale(1.1);
          }

          &::after {
            font-size: 20px;
            font-weight: bold;
          }
        }

        .swiper-button-next {
          right: -25px;
        }

        .swiper-button-prev {
          left: -25px;
        }
      }
    }

    /* 桌面版pagination樣式 */
    .custom-pagination {
      margin-top: 20px;

      .pagination-bullet {
        width: 10px;
        height: 10px;
        margin: 0 8px;

        &.active {
          transform: scale(1.5);
        }
      }
    }
  }
}

/* Additional safety rules to prevent header overflow */
.larger-banner-area {
  /* Prevent any overflow */
  overflow: hidden;

  /* Ensure proper stacking context */
  transform: translateZ(0);
}

/* 平板和較寬設備優化 (768px-1023px) */
@media (max-width: 1023px) and (min-width: 768px) {
  .larger-banner-area {
    .larger-banner-container {
      width: 70%; /* 平板設備使用較小比例 */
      max-width: 500px; /* 適合平板的最大寬度 */
    }
  }
}

/* 高解析度手機優化 (450px-768px) */
@media (max-width: 767px) and (min-width: 450px) {
  .larger-banner-area {
    .larger-banner-container {
      width: 85%; /* 高解析度手機使用較小比例 */
      max-width: 450px; /* 增加最大寬度 */
    }
  }
}

/* 主流手機優化 (720px-1080px 寬度) - 大部分Android/iOS */
@media (max-width: 450px) and (min-width: 360px) {
  .larger-banner-area {
    /* 完全貼合圖片，移除所有padding */
    padding: 0; /* 移除所有padding */
    min-height: 0; /* 移除最小高度 */

    .larger-banner-container {
      padding: 0; /* 移除所有padding */
      width: 98%; /* 增加寬度以減少留白 */

      .swiper-container {
        border-radius: 12px !important; /* 強制圓角 */
        overflow: hidden !important; /* 強制隱藏溢出 */
      }

      .swiper-slide {
        border-radius: 12px !important;
        overflow: hidden !important;

        a {
          border-radius: 12px !important;
          overflow: hidden !important;
        }

        img {
          border-radius: 12px !important;
        }
      }

      .swiper-button-next,
      .swiper-button-prev {
        width: 34px;
        height: 34px;

        &::after {
          font-size: 17px;
        }
      }
    }

    /* 最小化pagination間距 */
    .custom-pagination {
      margin-top: 6px; /* 最小間距 */
      margin-bottom: 6px; /* 最小下邊距 */
    }
  }
}

/* 小螢幕設備優化 (360px以下) - 入門機型 */
@media (max-width: 360px) {
  .larger-banner-area {
    /* 完全貼合，移除所有padding */
    padding: 0; /* 移除所有padding */
    min-height: 0;

    .larger-banner-container {
      padding: 0; /* 移除所有padding */
      width: 99%; /* 最大化寬度利用 */

      .swiper-container {
        border-radius: 12px !important;
        overflow: hidden !important;
      }

      .swiper-slide {
        border-radius: 12px !important;
        overflow: hidden !important;

        a {
          border-radius: 12px !important;
          overflow: hidden !important;
        }

        img {
          border-radius: 12px !important;
        }
      }

      .swiper-button-next,
      .swiper-button-prev {
        width: 32px;
        height: 32px;

        &::after {
          font-size: 16px;
        }
      }
    }

    /* 最小pagination間距 */
    .custom-pagination {
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }
}

/* 超小螢幕特別優化 (320px以下) - 極少數舊設備 */
@media (max-width: 320px) {
  .larger-banner-area {
    .larger-banner-container {
      padding: 0 2px; /* 極小padding */
      width: 99.5%; /* 幾乎全寬 */

      .swiper-button-next,
      .swiper-button-prev {
        width: 28px;
        height: 28px;

        &::after {
          font-size: 14px;
        }
      }
    }
  }
}
</style>